$(document).ready(function(){
   var f_image = $('.carousel__slide:first-child .product-media__image').attr("srcset");
   $('.main_collections_product_sec img').mouseover(function(){
    var image = $(this).attr("data-large-preview");
     //console.log(image);
    $(".carousel__slide:first-child .product-media__image").attr('src', image);
      $(".is-selected .product-media__image").removeAttr('srcset');
  });
  $('.main_collections_product_sec img').mouseleave(function(){
      $(".carousel__slide:first-child .product-media__image").prop('srcset', f_image);
  });

 
   $('.main_collections_product_sec img').mouseover(function(){
    var image = $(this).attr("data-large-preview");
     var sec_price = $(this).attr("price");
     $(this).parents('.shop__grid-item').addClass('product-selected').siblings('.shop__grid-item').removeClass('product-selected');
     var f_image = $('.shop__grid-item.product-selected .product-secondary-media').attr("srcset");
     var f_price = $('.shop__grid-item.product-selected .product-card__price-item ').text();
    $(".shop__grid-item.product-selected .product-secondary-media").attr('src', image);
      $(".shop__grid-item.product-selected .product-secondary-media").removeAttr('srcset');
     $('.shop__grid-item.product-selected .product-card__price-item ').text(sec_price);
    $('.main_collections_product_sec img').mouseleave(function(){
        $(".shop__grid-item.product-selected .product-secondary-media").prop('srcset', f_image);
       $('.shop__grid-item.product-selected .product-card__price-item ').text(f_price);
    });
  });
  $('.shop__grid-item .view-more').on('click', function(){
    $(this).parents('.shop__grid-item').addClass('product-selected').siblings('.shop__grid-item').removeClass('product-selected');
    $(this).css('display','none');
    $('.shop__grid-item.product-selected .hidden-li').addClass('block');
    
  });

    jQuery(document).on("click",".main_collections_product_sec  li img",function() {
      var prodcut_handle = $(this).attr('data-handle');
        console.log(prodcut_handle);
      var newurl = window.location.protocol + '//' + window.location.host +'/products/'+prodcut_handle;
      history.pushState({path: newurl}, '', newurl);
      $.ajax({
        url: newurl,
        type: 'GET',
        dataType: 'html', 
        success: function(res) {
          jQuery(document).find("#itg_main_product").html('');
          var product_data = $(res).find('#itg_main_product').html();
          jQuery(document).find("#itg_main_product").html(product_data);
        }
     });
    });

    jQuery(document).on("click",".main_collections_product_sec  li img",function() {
      var prodcut_handle = $(this).attr('data-handle');
        console.log(prodcut_handle);
      var newurl = window.location.protocol + '//' + window.location.host +'/products/'+prodcut_handle;
      history.pushState({path: newurl}, '', newurl);
     
      $.ajax({
        url: newurl,
        type: 'GET',
        dataType: 'html', 
        success: function(res) {
          jQuery(document).find("#itg_main_product #cstm-yotpo-review").text('');
          var product_data = $(res).find('#itg_main_product #cstm-yotpo-review').text();
          jQuery(document).find("#itg_main_product #cstm-yotpo-review").text(product_data);
        }
     });
    });


     jQuery(document).on("click",".main_collections_product_sec  li img",function() {
      var prodcut_handle = $(this).attr('data-handle');
        console.log(prodcut_handle);
      var newurl = window.location.protocol + '//' + window.location.host +'/products/'+prodcut_handle;
      history.pushState({path: newurl}, '', newurl);
      $.ajax({
        url: newurl,
        type: 'GET',
        dataType: 'html', 
        success: function(res) {
          jQuery(document).find("#itg_main_product_video").html('');
          var product_data = $(res).find('#itg_main_product_video').html();
          jQuery(document).find("#itg_main_product_video").html(product_data);
        }
     });
    });

    
  
    jQuery(document).on("click",".main_collections_product_sec  li img",function() {
      var prodcut_handle = $(this).attr('data-handle');
        console.log(prodcut_handle);
      var newurl = window.location.protocol + '//' + window.location.host +'/products/'+prodcut_handle;
      history.pushState({path: newurl}, '', newurl);
      $.ajax({
        url: newurl,
        type: 'GET',
        dataType: 'html', 
        success: function(res) {
          jQuery(document).find("#itg_main_product_del").html('');
          var product_data = $(res).find('#itg_main_product_del').html();
          jQuery(document).find("#itg_main_product_del").html(product_data);
        }
     });
    });

     jQuery(document).on("click",".main_collections_product_sec  li img",function() {
      var prodcut_handle = $(this).attr('data-handle');
        console.log(prodcut_handle);
      var newurl = window.location.protocol + '//' + window.location.host +'/products/'+prodcut_handle;
      history.pushState({path: newurl}, '', newurl);
      $.ajax({
        url: newurl,
        type: 'GET',
        dataType: 'html', 
        success: function(res) {
          jQuery(document).find("#itg_main_product_image-text").html('');
          var product_data = $(res).find('#itg_main_product_image-text').html();
          jQuery(document).find("#itg_main_product_image-text").html(product_data);
        }
     });
    });

    jQuery(document).on("click",".main_collections_product_sec  li img",function() {
      var prodcut_handle = $(this).attr('data-handle');
        console.log(prodcut_handle);
      var newurl = window.location.protocol + '//' + window.location.host +'/products/'+prodcut_handle;
      history.pushState({path: newurl}, '', newurl);
      $.ajax({
        url: newurl,
        type: 'GET',
        dataType: 'html', 
        success: function(res) {
          jQuery(document).find("#itg_main_product_area").html('');
          var product_data = $(res).find('#itg_main_product_area').html();
          jQuery(document).find("#itg_main_product_area").html(product_data);
        }
     });
    });

       jQuery(document).on("click",".main_collections_product_sec  li img",function() {
      var prodcut_handle = $(this).attr('data-handle');
        console.log(prodcut_handle);
      var newurl = window.location.protocol + '//' + window.location.host +'/products/'+prodcut_handle;
      history.pushState({path: newurl}, '', newurl);
      $.ajax({
        url: newurl,
        type: 'GET',
        dataType: 'html', 
        success: function(res) {
          jQuery(document).find("#itg_main_product_breadcrumbs").html('');
          var product_data = $(res).find('#itg_main_product_breadcrumbs').html();
          jQuery(document).find("#itg_main_product_breadcrumbs").html(product_data);
        }
     });
    });


     $('#cstm-yotpo-review-top').clone().appendTo('#review-2');
     jQuery(document).on("click",".main_collections_product_sec  li img",function() {
         setTimeout(function() {
       //alert('done');
      // $('#review-2').appendTo( $('#cstm-yotpo-review') ); // append -> object

        $('#cstm-yotpo-review-top').clone().appendTo('#review-2');
             }, 3000);
    });

  
      // tab with accordion js start****************************
  
      $("ul.tab-col li.tab").first().addClass("active");
      $(".tab-row .tab_accordion ul.accordion-col.tab-one").addClass("active");
      $(".tab").click(function(){
         $(".tab").removeClass("active");
         $(this).addClass("active");
        var first_value = $(this).attr("tab_id");
          $(".accordion-col").each(function(){
              var scnd_value = $(this).attr("acc_id");
              if(scnd_value == first_value ){
                  $(this).addClass("active");
              }
              else{
                  $(this).removeClass("active");
              }
          });
        });
      
        $(".que-col").click(function(){
            // $(".ans-col").removeClass("open");
            $(this).siblings().toggleClass("open");
            $(this).find(".icon_plus").toggleClass("remove");
        });
  
      // tab with accordion js end***************************
       
});


















                  


















                  